(function () {
    'use strict';

    a3_cabin_reports.directive('syllabusItemHeader', syllabusItemHeader);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name syllabusItemHeader
    * @restrict E
    * @description
    *   Panel heading for syllabus items
    * @example
    *   Usage:
    *   <syllabus-item-header></syllabus-item-header>
    * @ngInject
    */
    function syllabusItemHeader() {
        function link(scope, element, attrs) {
            scope.selectTry = selectTry;
            scope.selectGrading = selectGrading;

            //find first not ReadOnly try
            scope.pendingAttempt = scope.item.Tries.find(x => x.isFirstTry);
            scope.firstTry = scope.item.Tries[0];


            function selectTry(){
                if(scope.pendingAttempt){
                    scope.itemSelection();
                }
            }
            
            function selectGrading(){
                scope.gradingSelection();
            }

        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/Training/syllabus-item-header.tpl.html',
            scope: {item:"=", itemSelection: "&onItemSelection", gradingSelection: "&onGradingSelection"},
            link: link
        }
    }

})();
